/** Where a row leads: an Artwork address opens in place, another app's in its own page. */
export function inAppPath(url: string, here: string = window.location.origin): string | null {
  try {
    const target = new URL(url, here);
    if (target.origin !== here) return null;
    // The backend links a file as /file/:id; the editor lives at /f/:id.
    const path = target.pathname.replace(/^\/file\//, '/f/');
    return `${path}${target.search}${target.hash}`;
  } catch {
    return null;
  }
}
